import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-right"
      style={{
        zIndex: 9999,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast !bg-white !text-gray-900 !border-2 !border-gray-300 !shadow-2xl !opacity-100",
          description: "!text-gray-700 !font-medium !opacity-100",
          actionButton:
            "!bg-blue-600 !text-white hover:!bg-blue-700",
          cancelButton:
            "!bg-gray-200 !text-gray-900",
          success: "!bg-green-50 !border-green-500 !text-green-900",
          error: "!bg-red-50 !border-red-500 !text-red-900",
          warning: "!bg-yellow-50 !border-yellow-500 !text-yellow-900",
          info: "!bg-blue-50 !border-blue-500 !text-blue-900",
        },
        style: {
          opacity: '1 !important',
          background: 'white !important',
          backgroundColor: 'white !important',
          fontSize: '14px',
          fontWeight: '500',
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none',
        },
        duration: 4000,
      }}
      {...props} />
  );
}

export { Toaster, toast }
